import type { MedplumClient } from '@medplum/core';

/**
 * Drop cached reads of the resources the treatment-plan extract derives, so the chart
 * picks the CarePlan up once it lands.
 *
 * The extract itself is driven by the `extract-treatment-plan-careplan` subscription on
 * QuestionnaireResponse. The UI deliberately does not run the bot itself: `$execute`
 * returns 404 for provider memberships, so a direct call fails for exactly the users who
 * write treatment plans. The CarePlan is a derived projection of a QuestionnaireResponse
 * that is already safely persisted by this point, so a save must never block on it or
 * report failure when the extract lags.
 */
export function syncTreatmentPlanCarePlan(medplum: MedplumClient): void {
  medplum.invalidateSearches('CarePlan');
  medplum.invalidateSearches('Goal');
  medplum.invalidateSearches('Condition');
  medplum.invalidateSearches('EpisodeOfCare');
}
